"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2673],{

/***/ 2673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ getFieldProps; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./_config/index.js
var _config = __webpack_require__(8002);
// EXTERNAL MODULE: ./_constants/forms.js
var _constants_forms = __webpack_require__(5918);
// EXTERNAL MODULE: ./_constants/trademarkServices.js
var trademarkServices = __webpack_require__(8236);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(29);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./_services/index.js + 4 modules
var _services = __webpack_require__(4906);
// EXTERNAL MODULE: ./_helpers/file.js
var file = __webpack_require__(9140);
;// CONCATENATED MODULE: ./_helpers/forms/validators.js





var validateEmail = function validateEmail(options) {
  return /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(value) {
      var validationResult, _ref2, setValidating, useEmailVerificationService, emailValue, _yield$xVerifyService, status, reason, defaultMessage;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              validationResult = true;
              _ref2 = options || {}, setValidating = _ref2.setValidating, useEmailVerificationService = _ref2.useEmailVerificationService;

              if (!(useEmailVerificationService === false)) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", validationResult);

            case 4:
              if (setValidating) {
                setValidating(true);
              }

              emailValue = value;

              if (emailValue.indexOf('+') > -1 && emailValue.indexOf('gmail.com') > -1) {
                emailValue = emailValue.substring(0, emailValue.indexOf('+')) + emailValue.substring(emailValue.indexOf('@'), emailValue.length);
              }

              _context.next = 9;
              return _services/* xVerifyService.verifyEmail */.Tq.verifyEmail(emailValue);

            case 9:
              _yield$xVerifyService = _context.sent;
              status = _yield$xVerifyService.status;
              reason = _yield$xVerifyService.reason;

              if (_services/* xVerifyService.INVALID_EMAIL_STATUSES.includes */.Tq.INVALID_EMAIL_STATUSES.includes(status)) {
                defaultMessage = 'Email address is not valid'; // eslint-disable-next-line max-len, prettier/prettier

                validationResult = _services/* xVerifyService.VALIDATION_MESSAGE */.Tq.VALIDATION_MESSAGE[reason] || defaultMessage;
              }

              if (setValidating) {
                setValidating(false);
              }

              return _context.abrupt("return", validationResult);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var validateYear = function validateYear() {
  return function (value) {
    var currentDate = new Date();

    if (currentDate.getFullYear() - value >= 25) {
      return 'The year cannot be more than 1 year in the future or more than 25 years in the past.';
    }

    return true;
  };
};
var validateAddress = function validateAddress() {
  return function (value) {
    if (!/(?!.*(?:[pP][oO] [bB][oO][xX]))^[ a-zA-Z0-9\\/-]+$/.test(value) || !/(?!.*(?:[pP][oO][bB][oO][xX]))^[ a-zA-Z0-9\\/-]+$/.test(value) || !/(?!.*(?:[pP][oO][sS][tT] [oO][fF][fF][iI][cC][eE] [bB][oO][xX]))^[ a-zA-Z0-9\\/-]+$/.test(value) || /\bP(ost|ostal)?([ \.]*(O|0)(ffice)?)?([ \.]*Box)\b/i.test(value)) {
      return 'PO Boxes are not acceptable';
    }

    return true;
  };
};
var validateCardNumber = function validateCardNumber(options) {
  return function (value) {
    var _ref3 = options || {},
        erroredFields = _ref3.erroredFields;

    var isTestCard = value === '0000000000000000';
    return !isTestCard && erroredFields.cardNumber ? erroredFields.cardNumber : true;
  };
};
var validateCVC = function validateCVC(options) {
  return function () {
    var _ref4 = options || {},
        erroredFields = _ref4.erroredFields;

    return erroredFields.cvc || true;
  };
};
var validateCardMonth = function validateCardMonth(options) {
  return function (value) {
    var _ref5 = options || {},
        values = _ref5.values,
        clearErrors = _ref5.clearErrors,
        checkIfCardExpired = _ref5.checkIfCardExpired;

    var isCardExpired = checkIfCardExpired({
      cardMonth: value,
      cardYear: values[_constants_forms/* FIELDS_KEYS.cardYear */.mC.cardYear]
    });

    if (!isCardExpired) {
      clearErrors && clearErrors(_constants_forms/* FIELDS_KEYS.cardYear */.mC.cardYear);
    }

    return isCardExpired && values[_constants_forms/* FIELDS_KEYS.cardYear */.mC.cardYear] ? 'This card expired' : true;
  };
};
var validateCardYear = function validateCardYear(options) {
  return function (value) {
    var _ref6 = options || {},
        values = _ref6.values,
        clearErrors = _ref6.clearErrors,
        checkIfCardExpired = _ref6.checkIfCardExpired;

    var isCardExpired = checkIfCardExpired({
      cardMonth: values[_constants_forms/* FIELDS_KEYS.cardMonth */.mC.cardMonth],
      cardYear: value
    });

    if (!isCardExpired) {
      clearErrors && clearErrors(_constants_forms/* FIELDS_KEYS.cardMonth */.mC.cardMonth);
    }

    return isCardExpired && values[_constants_forms/* FIELDS_KEYS.cardMonth */.mC.cardMonth] ? 'This card expired' : true;
  };
};
var validateCategories = function validateCategories(options) {
  return function (value) {
    var _values$fieldName;

    var _ref7 = options || {},
        values = _ref7.values,
        fieldName = _ref7.fieldName;

    var categories = (_values$fieldName = values[fieldName]) === null || _values$fieldName === void 0 ? void 0 : _values$fieldName.map(function (item) {
      return item[_constants_forms/* FIELDS_KEYS.goodsCategory */.mC.goodsCategory];
    });

    if (categories.filter(function (category) {
      return category === value;
    }).length > 1) {
      return 'Duplication of categories is not allowed';
    }

    return true;
  };
};
var validatePhone = function validatePhone() {
  return function (value) {
    var pureNumber = value.replace(/\D/g, '');

    if (pureNumber.length !== 10) {
      return 'Phone number should be equal 10 symbols';
    }

    return true;
  };
};
var validateFileSize = function validateFileSize() {
  return function (value) {
    var fileSizeMb = value.size / 1024 / 1024;

    if (fileSizeMb > 5) {
      return 'File size exceeds 5 Mb';
    }

    return true;
  };
};
var validateLogoFile = function validateLogoFile(options) {
  return function (value) {
    var _ref8 = options || {},
        fileTypes = _ref8.fileTypes,
        noValidate = _ref8.noValidate;

    if (noValidate) {
      return true;
    }

    var _ref9 = (fileTypes === null || fileTypes === void 0 ? void 0 : fileTypes.find(function (_ref10) {
      var code = _ref10.code;
      return code === 'TRADEMARK_LOGO';
    })) || {},
        allowedExtensions = _ref9.allowedExtensions;

    var fileExtension = (0,file/* getFileExtension */.mD)(value === null || value === void 0 ? void 0 : value.name);
    var isExtensionAllowed = (0,file/* checkIfFileAllowed */.$Z)(fileExtension, allowedExtensions);

    if (!isExtensionAllowed) {
      return "Incorrect file type. Allowed ".concat((0,file/* getFileExtensionsString */._D)(allowedExtensions));
    }

    var fileSizeMb = value.size / 1024 / 1024;

    if (fileSizeMb > 5) {
      return 'File size exceeds 5 Mb';
    }

    return true;
  };
};
var validateSpecimenFile = function validateSpecimenFile(options) {
  return function (value) {
    var _ref11 = options || {},
        fileTypes = _ref11.fileTypes,
        noValidate = _ref11.noValidate;

    if (noValidate) {
      return true;
    }

    var _ref12 = (fileTypes === null || fileTypes === void 0 ? void 0 : fileTypes.find(function (_ref13) {
      var code = _ref13.code;
      return code === 'TRADEMARK_SPECIMEN';
    })) || {},
        allowedExtensions = _ref12.allowedExtensions;

    var fileExtension = (0,file/* getFileExtension */.mD)(value === null || value === void 0 ? void 0 : value.name);
    var isExtensionAllowed = (0,file/* checkIfFileAllowed */.$Z)(fileExtension, allowedExtensions);

    if (!isExtensionAllowed) {
      return "Incorrect file type. Allowed ".concat((0,file/* getFileExtensionsString */._D)(allowedExtensions));
    }

    var fileSizeMb = value.size / 1024 / 1024;

    if (fileSizeMb > 5) {
      return 'File size exceeds 5 Mb';
    }

    return true;
  };
};
var validateDescription = function validateDescription(options) {
  return function (value) {
    var _ref14 = options || {},
        defaultMessage = _ref14.defaultMessage;

    var cleanValue = value === null || value === void 0 ? void 0 : value.replace(/[\r\n]+/gm, ' ').replace(/\s{2,}/g, ' ').trim();

    if (!cleanValue) {
      return defaultMessage || 'Please provide Description';
    }

    return true;
  };
};
;// CONCATENATED MODULE: ./_helpers/forms/rules.js


var _RULES;



var RULES = (_RULES = {}, (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.firstName */.mC.firstName, function () {
  return {
    required: 'Please provide First Name',
    pattern: {
      value: /^[ a-zA-Z\\&-]+$/i,
      message: 'Firs Name should contain only letters and & \\ - symbols'
    },
    maxLength: {
      value: 30,
      message: 'First Name should be less or equal 30 symbols'
    }
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.middleName */.mC.middleName, function () {
  return {
    pattern: {
      value: /^[ a-zA-Z\\&-]+$/i,
      message: 'Middle Name should contain only letters and & \\ - symbols'
    },
    maxLength: {
      value: 30,
      message: 'Middle Name should be less or equal 30 symbols'
    }
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.lastName */.mC.lastName, function () {
  return {
    required: 'Please provide Last Name',
    pattern: {
      value: /^[ a-zA-Z\\&-]+$/i,
      message: 'Last Name should contain only letters and & \\ - symbols'
    },
    maxLength: {
      value: 30,
      message: 'Last Name should be less or equal 30 symbols'
    }
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.fullName */.mC.fullName, function () {
  return {
    required: 'Please provide Full Name',
    pattern: {
      value: /^[ a-zA-Z\\&-]+$/i,
      message: 'Full Name should contain only letters and & \\ - symbols'
    },
    maxLength: {
      value: 90,
      message: 'Full Name should be less or equal 90 symbols'
    }
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.subject */.mC.subject, function () {
  return {
    required: 'Please provide subject'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.message */.mC.message, function () {
  return {
    required: 'Please provide message',
    minLength: {
      value: 5,
      message: 'Message length must be between 5 and 2147483647'
    },
    maxLength: {
      value: 2147483647,
      message: 'Message length must be between 5 and 2147483647'
    }
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.phone */.mC.phone, function (options) {
  return {
    required: 'Please provide Phone number',
    validate: validatePhone(options)
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.address */.mC.address, function (options) {
  return {
    required: 'Please provide Address',
    pattern: {
      value: /^[ a-zA-Z0-9\\/-]+$/i,
      message: 'Address should contain only letters, numbers, dash or slash'
    },
    maxLength: {
      value: 30,
      message: 'Address should be less or equal 30 symbols'
    },
    validate: validateAddress(options)
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.email */.mC.email, function (options) {
  return {
    required: 'Please provide Email',
    pattern: {
      value: /^(?!.*(?:''|\.\.))([a-zA-Z0-9_\-\+\.]*[a-zA-Z0-9_\-])@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/i,
      message: 'Email address is not valid'
    },
    validate: validateEmail(options)
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.city */.mC.city, function () {
  return {
    required: 'Please provide City Name',
    pattern: {
      value: /^[ a-zA-Z/-]+$/i,
      message: 'City name should contain only letters and / - symbols'
    },
    maxLength: {
      value: 30,
      message: 'City name should be less or equal 30 symbols'
    }
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.state */.mC.state, function () {
  return {
    required: 'Please select a State/Province'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.zip */.mC.zip, function () {
  return {
    required: 'Please provide a zip code',
    pattern: {
      value: /[0-9]/i,
      message: 'Zip should contain only digits'
    },
    minLength: {
      value: 5,
      message: 'Zip should be equal 5 symbols'
    },
    maxLength: {
      value: 5,
      message: 'Zip should be equal 5 symbols'
    }
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.markDesc */.mC.markDesc, function (_ref) {
  var defaultMessage = _ref.defaultMessage;
  return {
    required: defaultMessage || 'Please provide a description'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.literalElements */.mC.literalElements, function () {
  return {
    required: 'Please provide the description'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.colorsInLogo */.mC.colorsInLogo, function () {
  return {
    required: 'Please provide the list of colors'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.firstUseAnywhereMonth */.mC.firstUseAnywhereMonth, function () {
  return {
    required: 'Please provide Month'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.firstUseAnywhereDay */.mC.firstUseAnywhereDay, function () {
  return {
    required: 'Please provide Day'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.firstUseAnywhereYear */.mC.firstUseAnywhereYear, function (options) {
  return {
    required: 'Please provide Year',
    validate: validateYear(options)
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.firstUseInCommerceMonth */.mC.firstUseInCommerceMonth, function () {
  return {
    required: 'Please provide Month'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.firstUseInCommerceDay */.mC.firstUseInCommerceDay, function () {
  return {
    required: 'Please provide Day'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.firstUseInCommerceYear */.mC.firstUseInCommerceYear, function (options) {
  return {
    required: 'Please provide Year',
    validate: validateYear(options)
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.logoFile */.mC.logoFile, function (options) {
  var _ref2 = options || {},
      noValidate = _ref2.noValidate;

  return {
    required: noValidate ? false : 'Logo file is not chosen',
    validate: validateLogoFile(options)
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.trademarkType */.mC.trademarkType, function () {
  return {
    required: 'Please choose the trademark type'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.ownName */.mC.ownName, function () {
  return {
    required: 'Please provide the name of the living person'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.translation */.mC.translation, function () {
  return {
    required: 'Please provide the English translation'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.individualOrgOrInd */.mC.individualOrgOrInd, function () {
  return {
    required: 'Please choose type of ownership'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.isNonUsBased */.mC.isNonUsBased, function () {
  return {
    required: 'Please choose formation'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.orgName */.mC.orgName, function () {
  return {
    required: 'Please provide Organization Name',
    pattern: {
      value: /[ a-zA-Z0-9/-]/i,
      message: 'Organization Name should contain only letters, numbers and / - symbols'
    },
    maxLength: {
      value: 30,
      message: 'Organization Name should be less or equal 30 symbols'
    }
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.orgType */.mC.orgType, function () {
  return {
    required: 'Please provide Organization Type'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.otherOrgType */.mC.otherOrgType, function () {
  return {
    required: 'Please specify Organization Type'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.orgState */.mC.orgState, function () {
  return {
    required: 'Please provide the State of Formation'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.orgPosition */.mC.orgPosition, function () {
  return {
    required: 'Please provide Position',
    pattern: {
      value: /[ a-zA-Z/-]/i,
      message: 'Position should contain only letters, spaces and / - symbols'
    },
    maxLength: {
      value: 30,
      message: 'Position should be less or equal 30 symbols'
    }
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.goodsCategory */.mC.goodsCategory, function (options) {
  return {
    required: 'Please choose Category',
    validate: validateCategories(options)
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.description */.mC.description, function () {
  return {
    required: 'Please provide additional description',
    maxLength: {
      value: 90,
      message: 'Description should be less or equal 90 symbols'
    }
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.processingOption */.mC.processingOption, function () {
  return {
    required: 'Please choose a Package'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.productCode */.mC.productCode, function () {
  return {
    required: 'Please choose a Package'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.cardNumber */.mC.cardNumber, function (options) {
  return {
    required: 'Please provide Card Number',
    validate: validateCardNumber(options)
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.cvc */.mC.cvc, function (options) {
  return {
    required: 'Please provide CVC/CVV',
    pattern: {
      value: /[0-9]/i,
      message: 'CVC/CVV should contain only digits'
    },
    minLength: {
      value: 3,
      message: 'CVC/CVV should contain 3 or 4 digits'
    },
    maxLength: {
      value: 4,
      message: 'CVC/CVV should contain 3 or 4 digits'
    },
    validate: validateCVC(options)
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.cardMonth */.mC.cardMonth, function (options) {
  return {
    required: 'You should provide Month',
    validate: validateCardMonth(options)
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.cardYear */.mC.cardYear, function (options) {
  return {
    required: 'You should provide Year',
    validate: validateCardYear(options)
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.billingAddressAddress1 */.mC.billingAddressAddress1, function (options) {
  return {
    required: 'Please provide Billing Address',
    pattern: {
      value: /^[ a-zA-Z0-9\\/-]+$/i,
      message: 'Address should contain only letters, numbers, dash or slash'
    },
    maxLength: {
      value: 30,
      message: 'Address should be less or equal 30 symbols'
    },
    validate: validateAddress(options)
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.billingAddressCity */.mC.billingAddressCity, function () {
  return {
    required: 'Please provide City Name',
    pattern: {
      value: /^[ a-zA-Z/-]+$/i,
      message: 'City name should contain only letters and / - symbols'
    },
    maxLength: {
      value: 30,
      message: 'City name should be less or equal 30 symbols'
    }
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.billingAddressState */.mC.billingAddressState, function () {
  return {
    required: 'Please select a State/Province'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.billingAddressZip */.mC.billingAddressZip, function () {
  return {
    required: 'Please provide a zip code',
    pattern: {
      value: /[0-9]/i,
      message: 'Zip should contain only digits'
    },
    minLength: {
      value: 5,
      message: 'Zip should be equal 5 symbols'
    },
    maxLength: {
      value: 5,
      message: 'Zip should be equal 5 symbols'
    }
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.agreeWithTerms */.mC.agreeWithTerms, function () {
  return {
    required: 'You should accept the terms to be able to proceed'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.serialNumber */.mC.serialNumber, function () {
  return {
    required: 'Please provide a valid Serial Number'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.markOwnerFirstName */.mC.markOwnerFirstName, function () {
  return {
    required: 'Please provide First Name',
    pattern: {
      value: /^[ a-zA-Z\\&-]+$/i,
      message: 'Firs Name should contain only letters and & \\ - symbols'
    },
    maxLength: {
      value: 30,
      message: 'First Name should be less or equal 30 symbols'
    }
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.markOwnerLastName */.mC.markOwnerLastName, function () {
  return {
    required: 'Please provide Last Name',
    pattern: {
      value: /^[ a-zA-Z\\&-]+$/i,
      message: 'Last Name should contain only letters and & \\ - symbols'
    },
    maxLength: {
      value: 30,
      message: 'Last Name should be less or equal 30 symbols'
    }
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.markOwnerPhone */.mC.markOwnerPhone, function (options) {
  return {
    required: 'Please provide Phone number',
    validate: validatePhone(options)
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.markOwnerEmail */.mC.markOwnerEmail, function (options) {
  return {
    required: 'Please provide Email',
    pattern: {
      value: /^(?!.*(?:''|\.\.))([a-zA-Z0-9_\-\+\.]*[a-zA-Z0-9_\-])@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/i,
      message: 'Email address is not valid'
    },
    validate: validateEmail(options)
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.newAddress */.mC.newAddress, function (options) {
  return {
    required: 'Please provide Address',
    pattern: {
      value: /^[ a-zA-Z0-9\\/-]+$/i,
      message: 'Address should contain only letters, numbers, dash or slash'
    },
    maxLength: {
      value: 30,
      message: 'Address should be less or equal 30 symbols'
    },
    validate: validateAddress(options)
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.newCity */.mC.newCity, function () {
  return {
    required: 'Please provide City Name',
    pattern: {
      value: /^[ a-zA-Z/-]+$/i,
      message: 'City name should contain only letters and / - symbols'
    },
    maxLength: {
      value: 30,
      message: 'City name should be less or equal 30 symbols'
    }
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.newState */.mC.newState, function () {
  return {
    required: 'Please select a State/Province'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.newZip */.mC.newZip, function () {
  return {
    required: 'Please provide a zip code',
    pattern: {
      value: /[0-9]/i,
      message: 'Zip should contain only digits'
    },
    minLength: {
      value: 5,
      message: 'Zip should be equal 5 symbols'
    },
    maxLength: {
      value: 5,
      message: 'Zip should be equal 5 symbols'
    }
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.newMarkOwnerFirstName */.mC.newMarkOwnerFirstName, function () {
  return {
    required: 'Please provide First Name',
    pattern: {
      value: /^[ a-zA-Z\\&-]+$/i,
      message: 'Firs Name should contain only letters and & \\ - symbols'
    },
    maxLength: {
      value: 30,
      message: 'First Name should be less or equal 30 symbols'
    }
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.newMarkOwnerLastName */.mC.newMarkOwnerLastName, function () {
  return {
    required: 'Please provide Last Name',
    pattern: {
      value: /^[ a-zA-Z\\&-]+$/i,
      message: 'Last Name should contain only letters and & \\ - symbols'
    },
    maxLength: {
      value: 30,
      message: 'Last Name should be less or equal 30 symbols'
    }
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.newMarkOwnerDescription */.mC.newMarkOwnerDescription, function () {
  return {
    required: 'Please provide a description'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.classesOrGoodsNotCovered */.mC.classesOrGoodsNotCovered, function () {
  return {
    required: 'Classes or Goods required'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.itemsCovered */.mC.itemsCovered, function () {
  return {
    required: 'Covered items required'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.itemsExtension */.mC.itemsExtension, function () {
  return {
    required: 'Extension items required'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.trademarkName */.mC.trademarkName, function () {
  return {
    required: 'Please provide a valid mark'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.classType */.mC.classType, function () {
  return {
    required: 'Please choose type of class'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.isSpecimenNeeded */.mC.isSpecimenNeeded, function () {
  return {
    required: 'Please choose an option'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.isClassesInUse */.mC.isClassesInUse, function () {
  return {
    required: 'Please choose an option'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.specimenFile */.mC.specimenFile, function (options) {
  var _ref3 = options || {},
      noValidate = _ref3.noValidate;

  return {
    required: noValidate ? false : 'Specimen file is not chosen',
    validate: validateSpecimenFile(options)
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.specimenUrl */.mC.specimenUrl, function () {
  return {
    required: 'Please provide specimen URL'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.timesDeadlineWasExtended */.mC.timesDeadlineWasExtended, function () {
  return {
    required: 'Please provide a number of extensions',
    pattern: {
      value: /[0-9]/i,
      message: 'Number of extensions should contain only digits'
    }
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.extensionReason */.mC.extensionReason, function () {
  return {
    required: 'Please select a reason'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.extensionReasonOther */.mC.extensionReasonOther, function () {
  return {
    required: 'Please describe other reason'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.service */.mC.service, function () {
  return {
    required: 'Please choose an option'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.officeActionStatus */.mC.officeActionStatus, function () {
  return {
    required: 'Please choose an option'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.statementOfUseStatus */.mC.statementOfUseStatus, function () {
  return {
    required: 'Please choose an option'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.privacyPackage */.mC.privacyPackage, function () {
  return {
    required: 'Please choose an option'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.logoName */.mC.logoName, function () {
  return {
    required: 'Please provide Exact Logo Wording/Business Name'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.businessIndustry */.mC.businessIndustry, function () {
  return {
    required: 'Please provide Business Industry'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.businessDescription */.mC.businessDescription, function () {
  return {
    required: 'Please provide Business Description'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.businessProducts */.mC.businessProducts, function () {
  return {
    required: 'Please provide Business Products/Services'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.targetAudience */.mC.targetAudience, function () {
  return {
    required: 'Please provide Target Audience for Customers'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.lettersType */.mC.lettersType, function () {
  return {
    required: 'Please choose Letters Type for the LOGO'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.customersConception */.mC.customersConception, function (options) {
  return {
    required: 'Please provide your Conception',
    validate: validateDescription(options)
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.logoCategory */.mC.logoCategory, function () {
  return {
    required: 'Please choose LOGO Category'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.logoUse */.mC.logoUse, function () {
  return {
    required: 'Please choose where the LOGO will be used'
  };
}), (0,defineProperty/* default */.Z)(_RULES, _constants_forms/* FIELDS_KEYS.logoUseDescription */.mC.logoUseDescription, function (options) {
  return {
    required: 'Please describe where the LOGO will be used',
    validate: validateDescription(options)
  };
}), _RULES);
var getValidationRules = function getValidationRules(fieldKey) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var getFieldRule = RULES[fieldKey];
  return getFieldRule ? getFieldRule(options) : undefined;
};
;// CONCATENATED MODULE: ./_helpers/forms/fields.js


var _fieldProps;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var fieldProps = (_fieldProps = {}, (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.firstName */.mC.firstName, {
  name: _constants_forms/* FIELDS_KEYS.firstName */.mC.firstName,
  label: 'First Name',
  placeholder: 'Enter First Name',
  required: true,
  onKeyPress: function onKeyPress(event) {
    if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
  }
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.fullName */.mC.fullName, {
  name: _constants_forms/* FIELDS_KEYS.fullName */.mC.fullName,
  label: 'Full Name',
  placeholder: 'Full Name',
  required: true,
  onKeyPress: function onKeyPress(event) {
    if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
  }
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.middleName */.mC.middleName, {
  name: _constants_forms/* FIELDS_KEYS.middleName */.mC.middleName,
  label: 'Middle Name (optional)',
  required: false,
  onKeyPress: function onKeyPress(event) {
    if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
  }
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.lastName */.mC.lastName, {
  name: _constants_forms/* FIELDS_KEYS.lastName */.mC.lastName,
  label: 'Last Name',
  placeholder: 'Enter Last Name',
  required: true,
  onKeyPress: function onKeyPress(event) {
    if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
  }
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.subject */.mC.subject, {
  name: _constants_forms/* FIELDS_KEYS.subject */.mC.subject,
  label: 'Subject',
  placeholder: 'Subject',
  required: true
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.message */.mC.message, {
  name: _constants_forms/* FIELDS_KEYS.message */.mC.message,
  label: 'Message',
  placeholder: 'Type your message',
  required: true
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.phone */.mC.phone, {
  name: _constants_forms/* FIELDS_KEYS.phone */.mC.phone,
  label: 'Phone',
  required: true,
  type: 'phone',
  mask: '(000) 000-0000',
  placeholder: '(123) 456-7890'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.email */.mC.email, {
  name: _constants_forms/* FIELDS_KEYS.email */.mC.email,
  label: 'Email',
  placeholder: 'Enter Email Address',
  required: true,
  type: 'email'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.address */.mC.address, {
  name: _constants_forms/* FIELDS_KEYS.address */.mC.address,
  required: true,
  label: 'Address',
  placeholder: 'Enter Address'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.city */.mC.city, {
  name: _constants_forms/* FIELDS_KEYS.city */.mC.city,
  required: true,
  label: 'City',
  placeholder: 'Enter City Name',
  onKeyPress: function onKeyPress(event) {
    if (!/[ a-zA-Z/-]/.test(event.key)) event.preventDefault();
  }
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.state */.mC.state, {
  name: _constants_forms/* FIELDS_KEYS.state */.mC.state,
  required: true,
  label: 'State/Province/Region',
  placeholder: 'Select a state',
  options: _constants_forms/* STATE_OPTIONS */.mZ
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.countryOfCitizenship */.mC.countryOfCitizenship, {
  name: _constants_forms/* FIELDS_KEYS.countryOfCitizenship */.mC.countryOfCitizenship,
  required: true,
  label: 'Country of Citizenship',
  options: _constants_forms/* COUNTRY_OPTIONS */.Yz
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.zip */.mC.zip, {
  name: _constants_forms/* FIELDS_KEYS.zip */.mC.zip,
  required: true,
  label: 'ZIP / Postal Code',
  placeholder: 'Enter ZIP / Postal Code',
  maxLength: '5',
  onKeyPress: function onKeyPress(event) {
    if (!/[0-9]/.test(event.key)) event.preventDefault();
  }
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.trademarkType */.mC.trademarkType, {
  name: _constants_forms/* FIELDS_KEYS.trademarkType */.mC.trademarkType,
  required: true,
  options: [{
    label: 'Name',
    value: 'NAME'
  }, {
    label: 'Slogan',
    value: 'SLOGAN'
  }, {
    label: 'Logo',
    value: 'LOGO'
  }]
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.markDesc */.mC.markDesc, {
  name: _constants_forms/* FIELDS_KEYS.markDesc */.mC.markDesc,
  required: true
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.trademarkName */.mC.trademarkName, {
  name: _constants_forms/* FIELDS_KEYS.trademarkName */.mC.trademarkName,
  required: true,
  placeholder: 'Enter the mark'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.literalElements */.mC.literalElements, {
  name: _constants_forms/* FIELDS_KEYS.literalElements */.mC.literalElements,
  required: true,
  label: 'Description of your logo',
  placeholder: 'Enter the description of your logo'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.logoColoredVariety */.mC.logoColoredVariety, {
  name: _constants_forms/* FIELDS_KEYS.logoColoredVariety */.mC.logoColoredVariety,
  labelOff: 'No',
  labelOn: 'Yes'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.colorsInLogo */.mC.colorsInLogo, {
  name: _constants_forms/* FIELDS_KEYS.colorsInLogo */.mC.colorsInLogo,
  required: true,
  label: 'A list of the colors that appear in your logo',
  placeholder: 'Enter the list of the colors'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.logoFile */.mC.logoFile, {
  name: _constants_forms/* FIELDS_KEYS.logoFile */.mC.logoFile,
  required: true,
  type: 'file',
  label: 'Upload logo file' // accept: '.png,.jpg,.jpeg,.pdf',

}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.isIncludeLivingPersonName */.mC.isIncludeLivingPersonName, {
  name: _constants_forms/* FIELDS_KEYS.isIncludeLivingPersonName */.mC.isIncludeLivingPersonName,
  labelOff: 'No',
  labelOn: 'Yes'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.isIncludeNicknameName */.mC.isIncludeNicknameName, {
  name: _constants_forms/* FIELDS_KEYS.isIncludeNicknameName */.mC.isIncludeNicknameName,
  labelOff: 'No',
  labelOn: 'Yes'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.ownName */.mC.ownName, {
  name: _constants_forms/* FIELDS_KEYS.ownName */.mC.ownName,
  required: true,
  label: 'Legal Name',
  placeholder: 'Enter the legal name'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.isOtherLivingName */.mC.isOtherLivingName, {
  name: _constants_forms/* FIELDS_KEYS.isOtherLivingName */.mC.isOtherLivingName,
  labelOff: 'No',
  labelOn: 'Yes'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.includeTranslationWords */.mC.includeTranslationWords, {
  name: _constants_forms/* FIELDS_KEYS.includeTranslationWords */.mC.includeTranslationWords,
  labelOff: 'No',
  labelOn: 'Yes'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.translation */.mC.translation, {
  name: _constants_forms/* FIELDS_KEYS.translation */.mC.translation,
  required: true,
  label: 'English translation',
  placeholder: 'Enter the English translation or transliteration'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.firstUseAnywhereYear */.mC.firstUseAnywhereYear, {
  name: _constants_forms/* FIELDS_KEYS.firstUseAnywhereYear */.mC.firstUseAnywhereYear,
  required: true,
  placeholder: 'Year'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.firstUseAnywhereMonth */.mC.firstUseAnywhereMonth, {
  name: _constants_forms/* FIELDS_KEYS.firstUseAnywhereMonth */.mC.firstUseAnywhereMonth,
  required: true,
  label: 'First Use Anywhere',
  placeholder: 'Month',
  options: _constants_forms/* MONTH_OPTIONS */.Sz
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.firstUseAnywhereDay */.mC.firstUseAnywhereDay, {
  name: _constants_forms/* FIELDS_KEYS.firstUseAnywhereDay */.mC.firstUseAnywhereDay,
  required: true,
  placeholder: 'Day',
  options: _constants_forms/* DAY_OPTIONS */.Pt
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.firstUseInCommerceYear */.mC.firstUseInCommerceYear, {
  name: _constants_forms/* FIELDS_KEYS.firstUseInCommerceYear */.mC.firstUseInCommerceYear,
  required: true,
  placeholder: 'Year'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.firstUseInCommerceMonth */.mC.firstUseInCommerceMonth, {
  name: _constants_forms/* FIELDS_KEYS.firstUseInCommerceMonth */.mC.firstUseInCommerceMonth,
  required: true,
  label: 'First Use In Commerce',
  placeholder: 'Month',
  options: _constants_forms/* MONTH_OPTIONS */.Sz
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.firstUseInCommerceDay */.mC.firstUseInCommerceDay, {
  name: _constants_forms/* FIELDS_KEYS.firstUseInCommerceDay */.mC.firstUseInCommerceDay,
  required: true,
  placeholder: 'Day',
  options: _constants_forms/* DAY_OPTIONS */.Pt
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.currentTrademark */.mC.currentTrademark, {
  name: _constants_forms/* FIELDS_KEYS.currentTrademark */.mC.currentTrademark,
  labelOff: 'No',
  labelOn: 'Yes'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.individualOrgOrInd */.mC.individualOrgOrInd, {
  name: _constants_forms/* FIELDS_KEYS.individualOrgOrInd */.mC.individualOrgOrInd,
  required: true,
  options: [{
    label: 'Individual',
    value: 'Individual'
  }, {
    label: 'Organization',
    value: 'Organization'
  }]
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.isNonUsBased */.mC.isNonUsBased, {
  name: _constants_forms/* FIELDS_KEYS.isNonUsBased */.mC.isNonUsBased,
  required: true,
  options: [{
    label: 'US Based',
    value: 'USBased'
  }, {
    label: 'Non US Based',
    value: 'NonUSBased'
  }]
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.orgName */.mC.orgName, {
  name: _constants_forms/* FIELDS_KEYS.orgName */.mC.orgName,
  required: true,
  label: 'Organization Name',
  placeholder: 'Organization Name',
  onKeyPress: function onKeyPress(event) {
    if (!/[ a-zA-Z0-9/-]/.test(event.key)) event.preventDefault();
  }
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.orgType */.mC.orgType, {
  name: _constants_forms/* FIELDS_KEYS.orgType */.mC.orgType,
  required: true,
  label: 'Organization Type',
  placeholder: 'Organization Type',
  options: _constants_forms/* ORG_TYPE_OPTIONS */.Iy
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.otherOrgType */.mC.otherOrgType, {
  name: _constants_forms/* FIELDS_KEYS.otherOrgType */.mC.otherOrgType,
  placeholder: 'Specify Type',
  required: true,
  options: _constants_forms/* OTHER_ORG_TYPE_OPTIONS */.gA
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.orgState */.mC.orgState, {
  name: _constants_forms/* FIELDS_KEYS.orgState */.mC.orgState,
  required: true,
  label: 'State of Formation',
  placeholder: 'State of Formation',
  options: _constants_forms/* STATE_OPTIONS */.mZ
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.formationCountry */.mC.formationCountry, {
  name: _constants_forms/* FIELDS_KEYS.formationCountry */.mC.formationCountry,
  required: true,
  label: 'Country of Citizenship',
  options: _constants_forms/* COUNTRY_OPTIONS */.Yz
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.orgPosition */.mC.orgPosition, {
  name: _constants_forms/* FIELDS_KEYS.orgPosition */.mC.orgPosition,
  required: true,
  label: 'Position',
  placeholder: 'CEO',
  onKeyPress: function onKeyPress(event) {
    if (!/[ a-zA-Z/-]/.test(event.key)) event.preventDefault();
  }
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.goods */.mC.goods, {
  name: _constants_forms/* FIELDS_KEYS.goods */.mC.goods,
  labelOff: 'Services',
  labelOn: 'Goods'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.goodsCategory */.mC.goodsCategory, {
  name: _constants_forms/* FIELDS_KEYS.goodsCategory */.mC.goodsCategory,
  required: true,
  placeholder: 'Start typing to search categories…'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.description */.mC.description, {
  name: _constants_forms/* FIELDS_KEYS.description */.mC.description,
  required: true,
  placeholder: 'Enter additional description'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.processingOption */.mC.processingOption, {
  name: _constants_forms/* FIELDS_KEYS.processingOption */.mC.processingOption,
  required: true
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.productCode */.mC.productCode, {
  name: _constants_forms/* FIELDS_KEYS.productCode */.mC.productCode,
  required: true
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.rush */.mC.rush, {
  name: _constants_forms/* FIELDS_KEYS.rush */.mC.rush
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.cardNumber */.mC.cardNumber, {
  name: _constants_forms/* FIELDS_KEYS.cardNumber */.mC.cardNumber,
  required: true,
  label: 'Card Number',
  placeholder: '0000 0000 0000 0000'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.cvc */.mC.cvc, {
  name: _constants_forms/* FIELDS_KEYS.cvc */.mC.cvc,
  // type: 'password',
  required: true,
  label: 'CVC/CVV',
  placeholder: 'CVC',
  maxLength: '4',
  onKeyPress: function onKeyPress(event) {
    if (!/[\d{3,4}]/.test(event.key)) {
      event.preventDefault();
    }
  }
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.cardMonth */.mC.cardMonth, {
  name: _constants_forms/* FIELDS_KEYS.cardMonth */.mC.cardMonth,
  required: true,
  label: 'Expiration date',
  placeholder: 'Month',
  options: _constants_forms/* MONTH_OPTIONS */.Sz
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.cardYear */.mC.cardYear, {
  name: _constants_forms/* FIELDS_KEYS.cardYear */.mC.cardYear,
  required: true,
  placeholder: 'Year'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.billingAddressAddress1 */.mC.billingAddressAddress1, {
  name: _constants_forms/* FIELDS_KEYS.billingAddressAddress1 */.mC.billingAddressAddress1,
  required: true,
  label: 'Billing Address',
  placeholder: 'Enter Address'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.billingAddressCity */.mC.billingAddressCity, {
  name: _constants_forms/* FIELDS_KEYS.billingAddressCity */.mC.billingAddressCity,
  required: true,
  label: 'City',
  placeholder: 'Enter City Name',
  onKeyPress: function onKeyPress(event) {
    if (!/[ a-zA-Z/-]/.test(event.key)) event.preventDefault();
  }
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.billingAddressState */.mC.billingAddressState, {
  name: _constants_forms/* FIELDS_KEYS.billingAddressState */.mC.billingAddressState,
  required: true,
  label: 'State',
  placeholder: 'Select a state',
  options: _constants_forms/* STATE_OPTIONS */.mZ
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.billingAddressZip */.mC.billingAddressZip, {
  name: _constants_forms/* FIELDS_KEYS.billingAddressZip */.mC.billingAddressZip,
  required: true,
  label: 'ZIP Code',
  placeholder: 'Enter ZIP Code',
  maxLength: '5',
  onKeyPress: function onKeyPress(event) {
    if (!/[0-9]/.test(event.key)) event.preventDefault();
  }
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.agreeWithTerms */.mC.agreeWithTerms, {
  name: _constants_forms/* FIELDS_KEYS.agreeWithTerms */.mC.agreeWithTerms,
  label: 'I accept the terms. I have read, understand, & agree to the terms of service.'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.isSerialNumber */.mC.isSerialNumber, {
  name: _constants_forms/* FIELDS_KEYS.isSerialNumber */.mC.isSerialNumber,
  labelOff: 'Don’t now it? Click here',
  labelOn: 'Serial Number'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.serialNumber */.mC.serialNumber, {
  name: _constants_forms/* FIELDS_KEYS.serialNumber */.mC.serialNumber,
  required: true
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.markOwnerFirstName */.mC.markOwnerFirstName, {
  name: _constants_forms/* FIELDS_KEYS.markOwnerFirstName */.mC.markOwnerFirstName,
  placeholder: 'Enter First Name',
  required: true,
  onKeyPress: function onKeyPress(event) {
    if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
  }
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.markOwnerLastName */.mC.markOwnerLastName, {
  name: _constants_forms/* FIELDS_KEYS.markOwnerLastName */.mC.markOwnerLastName,
  placeholder: 'Enter Last Name',
  required: true,
  onKeyPress: function onKeyPress(event) {
    if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
  }
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.markOwnerPhone */.mC.markOwnerPhone, {
  name: _constants_forms/* FIELDS_KEYS.markOwnerPhone */.mC.markOwnerPhone,
  required: true,
  type: 'phone',
  mask: '(000) 000-0000',
  placeholder: '(123) 456-7890'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.markOwnerEmail */.mC.markOwnerEmail, {
  name: _constants_forms/* FIELDS_KEYS.markOwnerEmail */.mC.markOwnerEmail,
  placeholder: 'Enter Email Address',
  required: true,
  type: 'email'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.isAddressSame */.mC.isAddressSame, {
  name: _constants_forms/* FIELDS_KEYS.isAddressSame */.mC.isAddressSame,
  labelOff: 'No',
  labelOn: 'Yes'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.isNewAddress */.mC.isNewAddress, {
  name: _constants_forms/* FIELDS_KEYS.isNewAddress */.mC.isNewAddress,
  labelOff: 'No',
  labelOn: 'Yes'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.newAddress */.mC.newAddress, {
  name: _constants_forms/* FIELDS_KEYS.newAddress */.mC.newAddress,
  required: true,
  label: 'Address',
  placeholder: 'Enter Address'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.newCity */.mC.newCity, {
  name: _constants_forms/* FIELDS_KEYS.newCity */.mC.newCity,
  required: true,
  label: 'City',
  placeholder: 'Enter City Name',
  onKeyPress: function onKeyPress(event) {
    if (!/[ a-zA-Z/-]/.test(event.key)) event.preventDefault();
  }
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.newState */.mC.newState, {
  name: _constants_forms/* FIELDS_KEYS.newState */.mC.newState,
  required: true,
  label: 'State/Province/Region',
  placeholder: 'Select a state',
  options: _constants_forms/* STATE_OPTIONS */.mZ
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.newZip */.mC.newZip, {
  name: _constants_forms/* FIELDS_KEYS.newZip */.mC.newZip,
  required: true,
  label: 'ZIP / Postal Code',
  placeholder: 'Enter ZIP / Postal Code',
  maxLength: '5',
  onKeyPress: function onKeyPress(event) {
    if (!/[0-9]/.test(event.key)) event.preventDefault();
  }
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.isNewDrawing */.mC.isNewDrawing, {
  name: _constants_forms/* FIELDS_KEYS.isNewDrawing */.mC.isNewDrawing,
  labelOff: 'No',
  labelOn: 'Yes'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.isMarkOwnerSame */.mC.isMarkOwnerSame, {
  name: _constants_forms/* FIELDS_KEYS.isMarkOwnerSame */.mC.isMarkOwnerSame,
  labelOff: 'No',
  labelOn: 'Yes'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.isNewMarkOwner */.mC.isNewMarkOwner, {
  name: _constants_forms/* FIELDS_KEYS.isNewMarkOwner */.mC.isNewMarkOwner,
  labelOff: 'No',
  labelOn: 'Yes'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.newMarkOwnerFirstName */.mC.newMarkOwnerFirstName, {
  name: _constants_forms/* FIELDS_KEYS.newMarkOwnerFirstName */.mC.newMarkOwnerFirstName,
  placeholder: 'Enter First Name',
  required: true,
  onKeyPress: function onKeyPress(event) {
    if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
  }
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.newMarkOwnerLastName */.mC.newMarkOwnerLastName, {
  name: _constants_forms/* FIELDS_KEYS.newMarkOwnerLastName */.mC.newMarkOwnerLastName,
  placeholder: 'Enter Last Name',
  required: true,
  onKeyPress: function onKeyPress(event) {
    if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
  }
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.newMarkOwnerDescription */.mC.newMarkOwnerDescription, {
  name: _constants_forms/* FIELDS_KEYS.newMarkOwnerDescription */.mC.newMarkOwnerDescription,
  required: true,
  placeholder: 'Provide an explanation for the change'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.isNoticeOfAllowanceCovered */.mC.isNoticeOfAllowanceCovered, {
  name: _constants_forms/* FIELDS_KEYS.isNoticeOfAllowanceCovered */.mC.isNoticeOfAllowanceCovered,
  labelOff: 'No',
  labelOn: 'Yes'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.classesOrGoodsNotCovered */.mC.classesOrGoodsNotCovered, {
  name: _constants_forms/* FIELDS_KEYS.classesOrGoodsNotCovered */.mC.classesOrGoodsNotCovered,
  required: true
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.isExtensionOnClasses */.mC.isExtensionOnClasses, {
  name: _constants_forms/* FIELDS_KEYS.isExtensionOnClasses */.mC.isExtensionOnClasses,
  labelOff: 'No',
  labelOn: 'Yes'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.itemsCovered */.mC.itemsCovered, {
  name: _constants_forms/* FIELDS_KEYS.itemsCovered */.mC.itemsCovered,
  required: true
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.itemsExtension */.mC.itemsExtension, {
  name: _constants_forms/* FIELDS_KEYS.itemsExtension */.mC.itemsExtension,
  required: true
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.classType */.mC.classType, {
  name: _constants_forms/* FIELDS_KEYS.classType */.mC.classType,
  required: true,
  options: [{
    label: 'Goods',
    value: 'GOODS'
  }, {
    label: 'Service',
    value: 'SERVICE'
  }, {
    label: 'Both',
    value: 'BOTH'
  }]
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.isSpecimenNeeded */.mC.isSpecimenNeeded, {
  name: _constants_forms/* FIELDS_KEYS.isSpecimenNeeded */.mC.isSpecimenNeeded,
  required: true,
  options: [{
    label: 'Yes',
    value: 'YES'
  }, {
    label: 'No',
    value: 'NO'
  }, {
    label: "I don't know",
    value: 'NO_ANSWER'
  }]
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.isClassesInUse */.mC.isClassesInUse, {
  name: _constants_forms/* FIELDS_KEYS.isClassesInUse */.mC.isClassesInUse,
  required: true,
  options: [{
    label: 'Yes, on all of the goods or services listed in the registration',
    value: 'YES_ON_ALL'
  }, {
    label: 'Yes, on some of the goods or services listed in the registration',
    value: 'YES_ON_SOME'
  }, {
    label: 'No',
    value: 'NO'
  }]
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.goodsServiceDetail */.mC.goodsServiceDetail, {
  name: _constants_forms/* FIELDS_KEYS.goodsServiceDetail */.mC.goodsServiceDetail,
  required: true,
  placeholder: 'Enter additional description'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.isSpecimenFile */.mC.isSpecimenFile, {
  name: _constants_forms/* FIELDS_KEYS.isSpecimenFile */.mC.isSpecimenFile,
  labelOff: 'URL',
  labelOn: 'File'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.specimenFile */.mC.specimenFile, {
  name: _constants_forms/* FIELDS_KEYS.specimenFile */.mC.specimenFile,
  required: true,
  type: 'file',
  label: 'Upload specimen file' // accept: '.png,.jpg,.jpeg,.pdf',

}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.specimenUrl */.mC.specimenUrl, {
  name: _constants_forms/* FIELDS_KEYS.specimenUrl */.mC.specimenUrl,
  required: true,
  placeholder: 'Enter the specimen URL'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.isExtendedInThePast */.mC.isExtendedInThePast, {
  name: _constants_forms/* FIELDS_KEYS.isExtendedInThePast */.mC.isExtendedInThePast,
  labelOff: 'No',
  labelOn: 'Yes'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.timesDeadlineWasExtended */.mC.timesDeadlineWasExtended, {
  name: _constants_forms/* FIELDS_KEYS.timesDeadlineWasExtended */.mC.timesDeadlineWasExtended,
  required: true,
  onKeyPress: function onKeyPress(event) {
    if (!/[0-9]/.test(event.key)) event.preventDefault();
  }
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.extensionReason */.mC.extensionReason, {
  name: _constants_forms/* FIELDS_KEYS.extensionReason */.mC.extensionReason,
  placeholder: 'Product or service research or development',
  required: true,
  options: _constants_forms/* EXTENSION_REASON_OPTIONS */.oU
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.extensionReasonOther */.mC.extensionReasonOther, {
  name: _constants_forms/* FIELDS_KEYS.extensionReasonOther */.mC.extensionReasonOther,
  required: true
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.service */.mC.service, {
  name: _constants_forms/* FIELDS_KEYS.service */.mC.service,
  required: true,
  options: [{
    label: "I didn't Respond to an Office Action",
    value: trademarkServices/* TRADEMARK_SERVICE_KEYS.officeActionResponse */.v.officeActionResponse
  }, {
    label: "I didn't File a Statement of Use",
    value: trademarkServices/* TRADEMARK_SERVICE_KEYS.statementOfUse */.v.statementOfUse
  }]
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.officeActionStatus */.mC.officeActionStatus, {
  name: _constants_forms/* FIELDS_KEYS.officeActionStatus */.mC.officeActionStatus,
  required: true,
  options: [{
    label: 'Only Procedural Issue(s) (e.g., disclaimer, specimen of use, description of mark, etc.)',
    value: 'PROCEDURAL_ISSUE_OFFICE_ACTION_TYPE'
  }, {
    label: 'It was Refused Registration (e.g., blocking mark, descriptive, last name, etc.)',
    value: 'REFUSED_REGISTRATION_OFFICE_ACTION_TYPE'
  }]
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.statementOfUseStatus */.mC.statementOfUseStatus, {
  name: _constants_forms/* FIELDS_KEYS.statementOfUseStatus */.mC.statementOfUseStatus,
  required: true,
  options: [{
    label: 'Yes, it is in use. File my Statement of Use',
    value: 'TRADEMARK_IN_USE'
  }, {
    label: 'No, it is not in use. File an my Extension of Time',
    value: 'TRADEMARK_NOT_IN_USE'
  }]
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.isOfficeAction */.mC.isOfficeAction, {
  name: _constants_forms/* FIELDS_KEYS.isOfficeAction */.mC.isOfficeAction
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.isKeepAlive */.mC.isKeepAlive, {
  name: _constants_forms/* FIELDS_KEYS.isKeepAlive */.mC.isKeepAlive
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.isCertifiedCopy */.mC.isCertifiedCopy, {
  name: _constants_forms/* FIELDS_KEYS.isCertifiedCopy */.mC.isCertifiedCopy
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.privacyPackage */.mC.privacyPackage, {
  name: _constants_forms/* FIELDS_KEYS.privacyPackage */.mC.privacyPackage,
  required: true
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.logoName */.mC.logoName, {
  name: _constants_forms/* FIELDS_KEYS.logoName */.mC.logoName,
  required: true,
  label: 'Exact Logo Wording/Business Name'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.slogan */.mC.slogan, {
  name: _constants_forms/* FIELDS_KEYS.slogan */.mC.slogan,
  label: 'Tagline/Slogan (Optional)'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.businessIndustry */.mC.businessIndustry, {
  name: _constants_forms/* FIELDS_KEYS.businessIndustry */.mC.businessIndustry,
  required: true,
  label: 'Business Industry'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.businessDescription */.mC.businessDescription, {
  name: _constants_forms/* FIELDS_KEYS.businessDescription */.mC.businessDescription,
  required: true,
  label: 'Business Description'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.businessProducts */.mC.businessProducts, {
  name: _constants_forms/* FIELDS_KEYS.businessProducts */.mC.businessProducts,
  required: true,
  label: 'Business Products/Services'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.targetAudience */.mC.targetAudience, {
  name: _constants_forms/* FIELDS_KEYS.targetAudience */.mC.targetAudience,
  required: true,
  label: 'Target Audience for Customers'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.businessWebsite */.mC.businessWebsite, {
  name: _constants_forms/* FIELDS_KEYS.businessWebsite */.mC.businessWebsite,
  label: 'Business Website (Optional)'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.lettersType */.mC.lettersType, {
  name: _constants_forms/* FIELDS_KEYS.lettersType */.mC.lettersType,
  required: true,
  label: 'How do you want your logo to be written ?',
  options: [{
    label: 'As it is (as shared above)',
    value: _constants_forms/* LETTERS_TYPE.AS_IT_IS */.dE.AS_IT_IS
  }, {
    label: 'In CAPITAL LETTERS',
    value: _constants_forms/* LETTERS_TYPE.UPPERCASE */.dE.UPPERCASE
  }, {
    label: 'In small letters',
    value: _constants_forms/* LETTERS_TYPE.LOWERCASE */.dE.LOWERCASE
  }]
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.customersConception */.mC.customersConception, {
  name: _constants_forms/* FIELDS_KEYS.customersConception */.mC.customersConception,
  required: true
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.logoCategory */.mC.logoCategory, {
  name: _constants_forms/* FIELDS_KEYS.logoCategory */.mC.logoCategory,
  required: true,
  label: 'Logo Categories',
  options: [{
    label: 'Just font (Just font without any symbolic intervention)',
    value: _constants_forms/* LOGO_CATEGORY.JUST_FONT */.EH.JUST_FONT,
    imgSrc: "".concat(_config/* config.basePath */.v.basePath, "/images/").concat(_constants_forms/* LOGO_CATEGORY.JUST_FONT */.EH.JUST_FONT, ".jpg")
  }, {
    label: 'Font + Meaning (A font with a tweak that symbolize company/product/service)',
    value: _constants_forms/* LOGO_CATEGORY.FONT_WITH_MEANING */.EH.FONT_WITH_MEANING,
    imgSrc: "".concat(_config/* config.basePath */.v.basePath, "/images/").concat(_constants_forms/* LOGO_CATEGORY.FONT_WITH_MEANING */.EH.FONT_WITH_MEANING, ".jpg")
  }, {
    label: 'Handmade (A calligraphic, handwritten or script font)',
    value: _constants_forms/* LOGO_CATEGORY.HANDMADE */.EH.HANDMADE,
    imgSrc: "".concat(_config/* config.basePath */.v.basePath, "/images/").concat(_constants_forms/* LOGO_CATEGORY.HANDMADE */.EH.HANDMADE, ".jpg")
  }, {
    label: 'Initials (Monogram with company name initials)',
    value: _constants_forms/* LOGO_CATEGORY.INITIALS */.EH.INITIALS,
    imgSrc: "".concat(_config/* config.basePath */.v.basePath, "/images/").concat(_constants_forms/* LOGO_CATEGORY.INITIALS */.EH.INITIALS, ".jpg")
  }, {
    label: 'Abstract graphic',
    value: _constants_forms/* LOGO_CATEGORY.ABSTRACT_GRAPHIC */.EH.ABSTRACT_GRAPHIC,
    imgSrc: "".concat(_config/* config.basePath */.v.basePath, "/images/").concat(_constants_forms/* LOGO_CATEGORY.ABSTRACT_GRAPHIC */.EH.ABSTRACT_GRAPHIC, ".jpg")
  }, {
    label: 'Silhouette (A detailed illustrated silhouette)',
    value: _constants_forms/* LOGO_CATEGORY.SILHOUETTE */.EH.SILHOUETTE,
    imgSrc: "".concat(_config/* config.basePath */.v.basePath, "/images/").concat(_constants_forms/* LOGO_CATEGORY.SILHOUETTE */.EH.SILHOUETTE, ".jpg")
  }, {
    label: 'Geometric symbol',
    value: _constants_forms/* LOGO_CATEGORY.GEOMETRIC_SYMBOL */.EH.GEOMETRIC_SYMBOL,
    imgSrc: "".concat(_config/* config.basePath */.v.basePath, "/images/").concat(_constants_forms/* LOGO_CATEGORY.GEOMETRIC_SYMBOL */.EH.GEOMETRIC_SYMBOL, ".jpg")
  }, {
    label: 'Illustrated symbol',
    value: _constants_forms/* LOGO_CATEGORY.ILLUSTRATED_SYMBOL */.EH.ILLUSTRATED_SYMBOL,
    imgSrc: "".concat(_config/* config.basePath */.v.basePath, "/images/").concat(_constants_forms/* LOGO_CATEGORY.ILLUSTRATED_SYMBOL */.EH.ILLUSTRATED_SYMBOL, ".jpg")
  }, {
    label: 'Emblem and Crests (Enclosed logo with just text or including graphics)',
    value: _constants_forms/* LOGO_CATEGORY.EMBLEM_AND_CRESTS */.EH.EMBLEM_AND_CRESTS,
    imgSrc: "".concat(_config/* config.basePath */.v.basePath, "/images/").concat(_constants_forms/* LOGO_CATEGORY.EMBLEM_AND_CRESTS */.EH.EMBLEM_AND_CRESTS, ".jpg")
  }, {
    label: 'Mascot (A character representing your Company)',
    value: _constants_forms/* LOGO_CATEGORY.MASCOT */.EH.MASCOT,
    imgSrc: "".concat(_config/* config.basePath */.v.basePath, "/images/").concat(_constants_forms/* LOGO_CATEGORY.MASCOT */.EH.MASCOT, ".jpg")
  }]
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.logoUse */.mC.logoUse, {
  name: _constants_forms/* FIELDS_KEYS.logoUse */.mC.logoUse,
  required: true,
  label: 'Where will you use your Logo?',
  options: [{
    label: 'Website',
    value: _constants_forms/* LOGO_USE.WEBSITE */.x2.WEBSITE
  }, {
    label: 'Business Stationery Printing',
    value: _constants_forms/* LOGO_USE.BUSINESS_STATIONARY_PRINTING */.x2.BUSINESS_STATIONARY_PRINTING
  }, {
    label: 'Signage / Billboards / Advertisement',
    value: _constants_forms/* LOGO_USE.ADVERTISING */.x2.ADVERTISING
  }, {
    label: 'Online Social Media',
    value: _constants_forms/* LOGO_USE.ONLINE_SOCIAL_MEDIA */.x2.ONLINE_SOCIAL_MEDIA
  }, {
    label: 'T-Shirt Printing',
    value: _constants_forms/* LOGO_USE.TSHIRT_PRINTING */.x2.TSHIRT_PRINTING
  }, {
    label: 'Car Wrap / Vinyls',
    value: _constants_forms/* LOGO_USE.CAR_WRAP */.x2.CAR_WRAP
  }, {
    label: 'Embroidery',
    value: _constants_forms/* LOGO_USE.EMBROIDERY */.x2.EMBROIDERY
  }, {
    label: 'Packaging',
    value: _constants_forms/* LOGO_USE.PACKAGING */.x2.PACKAGING
  }, {
    label: 'App Icon',
    value: _constants_forms/* LOGO_USE.APP_ICON */.x2.APP_ICON
  }, {
    label: 'Flyer / Brochure',
    value: _constants_forms/* LOGO_USE.FLYER */.x2.FLYER
  }, {
    label: 'Other',
    value: _constants_forms/* LOGO_USE.OTHER */.x2.OTHER
  }]
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.logoUseDescription */.mC.logoUseDescription, {
  name: _constants_forms/* FIELDS_KEYS.logoUseDescription */.mC.logoUseDescription,
  label: 'Provide where the LOGO will be used:'
}), (0,defineProperty/* default */.Z)(_fieldProps, _constants_forms/* FIELDS_KEYS.trademarkAssessment */.mC.trademarkAssessment, {
  name: _constants_forms/* FIELDS_KEYS.trademarkAssessment */.mC.trademarkAssessment
}), _fieldProps);
var getFieldProps = function getFieldProps(fieldKey) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      validationOptions = _ref.validationOptions;

  var props = fieldProps[fieldKey];
  return props ? _objectSpread(_objectSpread({}, props), {}, {
    rules: getValidationRules(fieldKey, validationOptions)
  }) : {};
};

/***/ })

}]);